<template>
  <section class="title-bar">
    <div class="hero-body">
      <p class="title">作業記録データを送信しました。トップページに戻ります。</p>
      <p class="subtitle"></p>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Top',
  mounted() {
    var me = this;
    setTimeout(() => {
      me.$router.push('/');
    }, 5000);
  },
};
</script>
<style scoped>
section.title-bar {
  background-color: #008a75;
}
p.title {
  color: white;
}
p.subtitle {
  color: white;
}
</style>


// WEBPACK FOOTER //
// src/components/Done.vue